import { BaseFloatDataChannel } from "./BaseDataChannel";

export class IMUChannel extends BaseFloatDataChannel {
  public getConfiguration() {
    return {
      name: 'imu'
    };
  }
}